import { render, staticRenderFns } from "./edit-zhuanbing-bianzheng.vue?vue&type=template&id=6a0f33b2&scoped=true&"
import script from "./edit-zhuanbing-bianzheng.vue?vue&type=script&lang=ts&"
export * from "./edit-zhuanbing-bianzheng.vue?vue&type=script&lang=ts&"
import style0 from "./edit-zhuanbing-bianzheng.vue?vue&type=style&index=0&id=6a0f33b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f33b2",
  null
  
)

export default component.exports